/**
 * IMPORTS
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

// typings
import {
  IStatusRemessaPayload,
  IStatusRemessaResponse,
} from "@/hooks/remessas/status-remessa-do-cliente/index.d";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

// domain / caso de usos
import { handleStatusRemessa } from "@/domain/use-cases/remessas/status-remessa";

const notifyError = (message: string) =>
  toast(message, {
    type: "error",
    position: "top-center",
  });

type IDataApi = {
  payload: IStatusRemessaPayload;
  id_remessa: number;
};

export function useStatusRemessa() {
  const queryClient = useQueryClient(); // ← necessário para invalidar a query
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<IStatusRemessaResponse, Error, IDataApi>({
    mutationFn: async ({ id_remessa, payload }: IDataApi) => {
      return await handleStatusRemessa(token!, id_remessa, payload);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["pega-tarefas-admin"],
      });
    },
    onError: (error) => {
      notifyError(`Erro ao atualizar o status da remessa: ${error.message}`);
    },
  });

  return {
    statusRemessa: mutation.mutate, // chamada direta
    statusRemessaAsync: mutation.mutateAsync, // se quiser await
    isLoadingSolicitarRemessa: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
